import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { ToggleButtonReuseTwo } from "../../../AllButton/ToggleButtonReuse";

import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from "../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import LeftSideNavigation from "../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

export const AdminCasualDiningEventManagement = (props) => {
  console.log("props of events",props)
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );
  const history = useHistory();
  const [state, setState] = useState({
    casualDiningOfflineEvent: false,
    casualDiningOnlineEvent: false,
  });

  const onClickCasualOfflineEvent = (e) => {
    if (state.casualDiningOfflineEvent === true) {
      setState({
        ...state,
        casualDiningOfflineEvent: !state.casualDiningOfflineEvent,
      });
    } else {
      history.push("/admin-casual-dining/event/offline");
    }
  };

  const onClickCasualOnlineEvent = (e) => {
    if (state.casualDiningOnlineEvent === true) {
      setState({
        ...state,
        casualDiningOnlineEvent: !state.casualDiningOnlineEvent,
      });
    } else {
      history.push("/admin-casual-dining/event/online");
    }
  };

  const onCasualOnlineEventSubmitClick = () => {
    let values = {
      value:
        state.casualDiningOfflineEvent === false &&
        state.casualDiningOnlineEvent === false
          ? false
          : true,
      offline_event: {
        value: state.casualDiningOfflineEvent,
      },
      online_event: {
        value: state.casualDiningOnlineEvent,
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    // formData.casual_dining_status.event_management = values;
    formData.casual_dining_status.event_management.value = values.value;
    formData.casual_dining_status.event_management.offline_event.value =
      values.offline_event.value;
    formData.casual_dining_status.event_management.online_event.value =
      values.online_event.value;
    // console.log(subscriptionId, formData, token);
    props.admin_update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Events subscription add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push(
      props.editDataAction
        ? "/admin-edit-add-subscription"
        : "/admin-add-subscription"
    );
  };

  useEffect(() => {
    setState({
      ...state,
      casualDiningOfflineEvent:
        props.subscriptionData &&
        props.subscriptionData.offline_event &&
        props.subscriptionData.offline_event.value !== undefined
          ? props.subscriptionData &&
            props.subscriptionData.offline_event &&
            props.subscriptionData.offline_event.value
          : false,
      casualDiningOnlineEvent:
        props.subscriptionData &&
        props.subscriptionData.online_event &&
        props.subscriptionData.online_event.value !== undefined
          ? props.subscriptionData &&
            props.subscriptionData.online_event &&
            props.subscriptionData.online_event.value
          : false,
    });
  }, [props.subscriptionData]);

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                // id="onboarding-scrollbar"
                className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 new-subscription-onboarding-component px-5 pt-4"
              >
                <div className="col-8 onboarding_process_screen-button-map inside-subscription-offers-section p-0">
                  <TopTextReusableComponent headingText="Events Management" />
                  <div className="col-12 p-0">
                    <div className="f16-700 my-4">Activate Events Types</div>
                    <ToggleButtonReuseTwo
                      mainText="Offline Events"
                      paragraphText="(Note: Events are in a physical venue and you can even accept RSVP)"
                      checkedBox={state.casualDiningOfflineEvent}
                      onChange={onClickCasualOfflineEvent}
                      disabled={disabled}
                    />
                    <hr className="mt-5 mb-5" />
                    <ToggleButtonReuseTwo
                      mainText="Online Events"
                      paragraphText="(Note: Events are online you need a link stored at the time of events creation You can accept RSVP for the events)"
                      checkedBox={state.casualDiningOnlineEvent}
                      onChange={onClickCasualOnlineEvent}
                      disabled={disabled}
                    />
                  </div>
                  <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link={
                        props.editDataAction
                          ? "/admin-edit-add-subscription"
                          : "/admin-add-subscription"
                      }
                    />
                    {!disabled && (
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Done"
                        buttonType="button"
                        onClick={onCasualOnlineEventSubmitClick}
                        disabled={disabled}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

AdminCasualDiningEventManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.event_management,
  allSubscriptionsData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
})(withRouter(AdminCasualDiningEventManagement));
